import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';
import React from 'react';

interface MuiAlertProps {
  open: boolean;
  ms: number;
  handleClose: () => void;
  message: string | React.ReactNode;
  successful: boolean;
  warning?: boolean;
}

function Alert(props: AlertProps) {
  return <MuiAlert elevation={20} variant="filled" {...props} />;
}

const CustomAlert = ({
  open,
  ms,
  handleClose,
  message,
  successful,
  warning,
}: MuiAlertProps) => {
  return (
    <Snackbar open={open} autoHideDuration={ms} onClose={handleClose}>
      {successful ? (
        <Alert onClose={handleClose} severity="success">
          {message}
        </Alert>
      ) : (
        <Alert severity={warning ? 'warning' : 'error'}>{message}</Alert>
      )}
    </Snackbar>
  );
};

export default CustomAlert;
